// src/hooks/useNoticias.jsx
import { useState, useEffect } from 'react';
import axios from 'axios';

const useNoticias = (perPage = 5) => {
  const [noticias, setNoticias] = useState([]);

  useEffect(() => {
    const fetchNoticias = async () => {
      try {
        const baseUrl = process.env.REACT_APP_API_URL;
        if (!baseUrl) {
          console.error('❌ REACT_APP_API_URL no está definida en .env');
          return;
        }

        // Asegúrate de no duplicar barras al final
        const endpoint = `${baseUrl.replace(/\/+$/, '')}/noticias`;

        const res = await axios.get(endpoint, {
          params: {
            populate: 'previsualizacion',
            sort: 'publishedAt:desc',
            'pagination[limit]': perPage,
          },
        });

        const items = res.data.data || [];
        const arr = items.map((item) => {
          const mediaArr = item.previsualizacion || [];
          const src = mediaArr.length > 0 ? mediaArr[0].url : '';

          // Si te llega ruta relativa, la anteponemos al mismo baseUrl
          const previsualizacion = src.startsWith('http')
            ? src
            : `${baseUrl.replace(/\/+$/, '')}${src}`;

          return {
            id: item.id,
            titulo: item.titulo || 'Sin título',
            previsualizacion,
            descripcion: item.descripcion || '',
            slug: item.slug || '',
          };
        });

        setNoticias(arr);
      } catch (err) {
        console.error('Error fetching noticias:', err);
      }
    };

    fetchNoticias();
  }, [perPage]);

  return noticias;
};

export default useNoticias;
